import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../shared";
import { AppletNotificationHdrModel } from "../../../../../models/aggregates/applet/applet_notification_hdr.model";

@Injectable({providedIn: 'root'})
export class AppletNotificationHdrService extends BaseApiTemplateService<AppletNotificationHdrModel> {
    constructor(http: HttpClient) {
        super();
        this.apiUrl =
        Core2Config.DOMAIN_URL +
        Core2Config.TENANT_DOMAIN_URL_PREFIX + 
        'applet/notifications';
    this.httpClient = http;
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + 
    'applet/notifications';
    }
}
